// extracted by mini-css-extract-plugin
export default {"container":"HelicopterPage_container__hqNsY","title":"HelicopterPage_title__VZiCQ","gameContainer":"HelicopterPage_gameContainer__+gb+D"};